import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { PaypalObjectDataset } from 'app/model/dataset/paypal.dataset';
import { Metamodel } from 'app/model/base/model';
import { PaypalLinkedService } from 'app/model/linkedservice/paypal.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const payPalObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(PaypalObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Paypal_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(PaypalLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-paypal'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
